<template>
    <div>
        <b-modal id="modal-prevent-closing" class="header-modal" no-close-on-backdrop hide-footer ref="modal-help-create-modal">
            <div class="modal-help-create-modal__body">
                <h4>
                    <strong>
                        {{ dataItem.name }}
                    </strong>
                </h4>
                
                <PreviewVideo :pathView="dataVideoHelper.path ? `${appUrl}${dataVideoHelper.path}` : dataVideoHelper.pathView " />
                <div class="modal__actions text-right">
                    <a href="javascript:;" class="primary-color-txt font-size-17 btn-cancel" @click="handleHideModal">Đóng</a>
                    
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import PreviewVideo from '@/components/content-files/PreviewVideo.vue'
import { APP_CONFIG } from '@/utils/constants'
import {apiHelpGetVideo} from './../../../../../store/common/api'
export default {
    name: "ModalShowHelpCreateExcercise",
    components:{
        PreviewVideo
    },
    props: {
        dataItem:{
            type:Object,
            // eslint-disable-next-line vue/require-valid-default-prop
            default:{}
        }
    },
    data() {
        return {
            appUrl: APP_CONFIG.bookCdnUrl,
            confirmActive: {},
            isLoading: false,
            dataVideoHelper:{}
        }
    },
    mounted(){
        this.handleShowModal()
        this.getVideoHelp()
    },
    computed: {
        screenWidth() {
            return window.innerWidth;
        },
        
    },
    methods: {
        getVideoHelp(){
            apiHelpGetVideo(this.dataItem.typeId).then((res)=>{
                if (res && res.data && !res.errors) {
                    this.dataVideoHelper = res.data.data
                    console.log(this.dataVideoHelper)
                }
            })
        },
        handleHideModal() {
            this.$emit('closeModal')
        },
        handleShowModal() {
            this.$refs['modal-help-create-modal'].show()
        }
    }
}
</script>
<style lang="scss" scoped>
.modal-content {
    background-color: red;
}

.modal-help-create-modal__body {
    padding: 20px;
    background-color: white;
    border-radius: 15px;
    .modal__actions{
        
        .btn-cancel{
            margin-right: 10px;
            font-family: sans-serif;
        }
    }
}

.form_action {
    margin-top: 10px;
    padding-bottom: 10px;
}

.justity-content-space-between {
    justify-content: center
}
</style>